export default function CGets() {
  return <h2>C Gets</h2>;
}
